import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { aberdeenConfig } from "./data";

export default function AberdeenPage() {
  return <CityPageTemplate config={aberdeenConfig} />;
}